export default __webpack_public_path__ + "static/media/imageSVG.7849e405.svg";